<template>
  <div v-click-outside="away"  class="engineAutoComplete">
    <div  class="box" >
      <div class="text" @click="toggleSelect(true)">
<!--        <span v-html="this.closeIcon"></span>-->
        <input :placeholder="selected" v-model="search"  class="boxSelect"/>
        <!-- {{selected}} -->
        <span style="flex: auto"></span>
      </div>
      <span class="arrow" @click="clearSearch()">  <span v-html="this.closeIcon"></span> </span>
    </div>
    <div  v-if="openSelect" class="optionsContainer">
<!--      <VuePerfectScrollbar>-->
        <div @click="selectOption(option)" class="option" v-for="option in filterOptions(search)" :key="option.name">
          <div class="optionText" > {{option.name}} </div>
        </div>
        <div class="option" v-if="filterOptions(search).length < 1">
          <div class="optionText" > No results </div>
        </div>
<!--      </VuePerfectScrollbar>-->
    </div>
  </div>
</template>
<script>

//import VuePerfectScrollbar from 'vue-perfect-scrollbar';
// import EngineService from "../services/enginesService";
// import SelectedEngine from "../services/selectedEngineService";

import axios from "axios";
import iconService from "../services/iconService";
import WlAuthService from "@/services/WlAuthService";

export default {
  name: 'AutocompleteComponent',
  components: {
  },
  data: () => ({
    selected: "Select filter...",
    options: [],
    openSelect: false,
    search: "",
    SelectedResource: {},
    closeIcon: iconService.icons.Close,
    WlAuthService: WlAuthService
  }),
  created() {
    axios.get(process.env.VUE_APP_API_URL+'/resources', {
      headers:{'Content-Type': 'application/json', 'email':this.getCookie('email'), 'usertoken': this.getCookie('usertoken')}
    }).then((response)=>{
      console.log("AC response",response);
      this.options = response.data.sort((a, b) => a.name.localeCompare(b.name)); 
    }).catch((error)=>{
      console.log("error", error)
    })
  },
  mounted(){

  },
  methods: {
    toggleSelect(value){
      if(value){
        this.openSelect = true;
      }
      else{
        this.openSelect = false;
      }
    },
    selectOption(option){
      this.selected = option.name;
      this.search = option.name;
      this.openSelect = false;
      this.$emit('selected', option);
    },
    away(){
      this.search = "";
      this.openSelect = false;
    },
    filterOptions(search){
      if(search == ""){
        return this.options;
      }
      else{
        console.log("filter", search);
        return this.options.filter((option)=>{
          //console.log("filter", option.engine_name.toLowerCase().indexOf(search.toLowerCase()) !== -1);
          return option.name.toLowerCase().indexOf(search.toLowerCase()) !== -1;
        });
      }

    },
    clearSearch(){
      this.search = "";
      this.selected =  "Select filter...";
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }
};
</script>
<style scoped>
.engineAutoComplete {
  width: 80%;
}
.box {
  padding: 0 12px;
  flex-direction: row;
  display: flex;
  width: 100%;
  height: 50px;
  font-size: 15px;
  color: #666666;
  background-color: white;
  border: 1px solid #D1D0D4;
  border-radius: 5px;
  align-items: center;
  cursor: pointer;
}
.text{
  flex: auto;
}
.boxSelect{
  width: 100%;
  height: 95%;
  display: flex;
  color: #666666;
  font-size: 15px;
  border: none;
  background-color: white;
  margin-right: 10px;
  outline: none;
}
.clear{
  margin-right: 15px;
}
.arrow{

  font-size: 20px;
  margin-right: 5px;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .optionsContainer {
    overflow-y: scroll;
  }
}
.optionsContainer {
  width: 400px;
  max-height: 600px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 6px 0 rgba(0, 0, 0, 0.19);
  background-color: #F5F5FA;
  font-size: 15px;
  border: 1px solid #D1D0D4;
  flex-direction: column;
  display: flex;
  z-index: 6;
  position: absolute;
  border-radius: 5px;
}
.option{
  height: 50px;
  display: flex;
  flex-direction: row;
  color: #8A8A8F;
  align-items: center;
  padding: 0 15px;

}
.option:hover{
  cursor: pointer;
  background-color: #8A8A8F;
  color:  #F5F5FA;
}
</style>